import { createContext } from 'react';

import { useGroupsQuery } from './use-groups-query';

/**
 * The context can be used to inject any kind of
 * dependency, but mainly hooks and components/containers.
 *
 * The main purpose is to facilitate testing
 * and storybooking without having to make complex mocks
 * - and to keep the components as simple as possible.
 */

export interface UseGroupsQueryContextInterface {
  useGroupsQuery: typeof useGroupsQuery;
}

let context: React.Context<UseGroupsQueryContextInterface>;

export const getGroupsQueryContext = () => {
  if (!context) {
    context = createContext({
      useGroupsQuery,
    });
  }

  return context;
};
